import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';


const Button = ({ theme, square, small, icon, disabled, progress, percentage, submit, value, to, toOutside, download, onClick, className }) => {
	// const buttonClassName = classnames(
	// 	'flex items-center px-4 font-bold rounded-lg ring-offset-2 ring-offset-white dark:ring-offset-neutral-800 focus:ring transition-all disabled:opacity-60 disabled:cursor-not-allowed',
	// 	small && 'h-7',
	// 	!small && 'h-9',
	// 	(small && square) && 'w-7 justify-center',
	// 	(!small && square) && 'w-9 justify-center',
	// 	!theme && 'text-neutral-800 bg-neutral-100 hover:bg-neutral-200 focus:ring-neutral-200 disabled:hover:bg-neutral-200 dark:bg-neutral-600 dark:hover:bg-neutral-700 dark:text-white dark:focus:ring-neutral-600',
	// 	theme === 'success' && 'text-white bg-emerald-500 hover:bg-emerald-600 hover:text-white focus:ring-emerald-500 disabled:hover:bg-emerald-500',
	// 	theme === 'warning' && 'text-white bg-amber-500 hover:bg-amber-600 hover:text-white focus:ring-amber-500 disabled:hover:bg-amber-500',
	// 	theme === 'danger' && 'text-white bg-red-500 hover:bg-red-600 hover:text-white focus:ring-red-500 disabled:hover:bg-red-500',
	// 	className
	// );

	const buttonClassName = twMerge(
		'flex-shrink-0 flex items-center px-4 h-9 gap-2 font-bold rounded-lg ring-offset-2 ring-offset-white dark:ring-offset-neutral-800 focus:ring transition-all disabled:opacity-60 disabled:cursor-not-allowed',
		!theme && 'text-neutral-800 hover:text-neutral-800 bg-neutral-100 hover:bg-neutral-200 focus:ring-neutral-200 disabled:hover:bg-neutral-200 dark:bg-neutral-600 dark:hover:bg-neutral-700 dark:text-white dark:focus:ring-neutral-600',
		theme === 'success' && 'text-white bg-emerald-500 hover:bg-emerald-600 hover:text-white focus:ring-emerald-500 disabled:hover:bg-emerald-500',
		theme === 'warning' && 'text-white bg-amber-500 hover:bg-amber-600 hover:text-white focus:ring-amber-500 disabled:hover:bg-amber-500',
		theme === 'danger' && 'text-white bg-red-500 hover:bg-red-600 hover:text-white focus:ring-red-500 disabled:hover:bg-red-500',
		theme === 'informative' && 'text-white bg-indigo-500 hover:bg-indigo-600 hover:text-white focus:ring-indigo-500 disabled:hover:bg-indigo-500',
		square && 'px-0 w-9 justify-center',
		small && 'h-7',
		(square && small) && 'w-7',
		className
	);

	if (toOutside) {
		return (
			<a
				target="_blank"
				rel="noreferrer"
				href={toOutside}
				download={download}
				className={buttonClassName}
			>
				{value}

				{/* Show icon if passed */}
				<Show if={icon && !progress}>
					<Icon icon={icon} className="font-normal" />
				</Show>
			</a>
		);
	}

	if (to) {
		return (
			<Link
				to={to}
				onClick={onClick}
				disabled={disabled}
				className={buttonClassName}
			>
				{value}

				{/* Show icon if passed */}
				<Show if={icon && !progress}>
					<Icon icon={icon} className="font-normal" />
				</Show>
			</Link>
		);
	}

	return (
		<button
			type={submit ? 'submit' : 'button'}
			disabled={disabled || progress}
			onClick={onClick}
			className={buttonClassName}
		>
			{value}

			{/* Show progress percentage */}
			<Show if={progress && percentage && progress !== 100}>
				<div className="">
					{percentage}%
				</div>
			</Show>

			{/* Show icon if passed */}
			<Show if={icon && !progress}>
				<Icon icon={icon} className="font-normal" />
			</Show>

			{/* Show progress if passed */}
			<Show if={progress}>
				<svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
					<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
					<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
				</svg>
			</Show>
		</button>
	);
};

export default Button;